import { MenuProps } from "@/layout/Navbar/Side/SideDrawer";

export const mainKoleksiNavMenus: MenuProps[] = [
  {
    title: "Koleksi Bahan Pustaka",
    path: "/koleksi"
  },
  {
    title: "Rekomendasi Anda",
    path: "/rekomendasi"
  },
  {
    title: "Tambah Pinjaman",
    path: "/pinjam"
  },
  {
    title: "Riwayat Pinjaman",
    path: "/riwayat-pinjaman"
  },
  {
    title: "Riwayat Baca",
    path: "/riwayat-baca"
  },
  {
    title: "Penanda Koleksi",
    path: "/penanda-koleksi"
  }
];

//TODO Tambah Pinjam -> Buka dialog